


















import { Component, Prop, Vue } from "vue-property-decorator";
import Stat from "@/components/app/global/stats/stat/index.vue";

@Component({
  components: {
    Stat
  }
})
export default class DateRangeStat extends Vue {
  public $refs!: {
    stat: Stat;
  };

  // Props
  @Prop({ default: null })
  public dateFrom!: Date;

  @Prop({ default: null })
  public dateTo!: Date;

  @Prop({ required: false, default: () => null })
  public valueFunc!: (arg: any) => any;

  // Getters
  public get listeners() {
    return this.$listeners;
  }

  public get params() {
    // If no dates are provided show all until now
    if (!this.$_.isDate(this.dateFrom) && !this.$_.isDate(this.dateTo)) {
      return {
        ...(this.$attrs.params as any),
        date_to: this.$moment().format("YYYY-MM-DD")
      };
    }

    // Show in range
    const dateFrom = this.dateFrom;
    const dateTo = this.dateTo;
    return {
      ...(this.$attrs.params as any),
      ...(dateFrom
        ? { date_from: this.$moment(dateFrom).format("YYYY-MM-DD") }
        : {}),
      date_to: this.$moment(dateTo).format("YYYY-MM-DD")
    };
  }

  // Methods
  public recalculateStatValue() {
    return this.$refs.stat?.recalculateStatValue();
  }

  public async calculateValue(args) {
    if (!!this.valueFunc && this.$_.isFunction(this.valueFunc))
      return await this.valueFunc(args);

    const { data, defaultValue, currency, currencyBound } = args;
    if (!data && this.$_.isNil(data)) {
      const prefix = this.$_.get(currency, "prefix", "");
      const suffix = this.$_.get(currency, "suffix", "");

      return currencyBound
        ? `${prefix} ${defaultValue} ${suffix}`
        : defaultValue;
    }
    return data;
  }
}
